type ValueIdNameWithColorT = { id: string; name: string; color: string; created_at: string };

export const isIdNameValueWithColorT = (item: unknown): item is ValueIdNameWithColorT => {
  return (
    typeof item === 'object' && item !== null && 'color' in item && typeof (item as ValueIdNameWithColorT).color === 'string'
  );
};
